<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      spinner="bar-fade-scale"
      color="#1976d2"
      size="128"
      :is-full-screen="false"
    />
    <v-snackbar v-model="showsnackbar" color="black" right>
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout v-if="ServerError" wrap justify-center>
      <v-flex px-5 pt-5 xs12 sm12 md12 lg12 xl12 text-center>
        <ServerError />
      </v-flex>
    </v-layout>
    <v-layout wrap v-else>
      <v-flex px-5 pt-5 xs12 sm12 md12 lg12 xl12 text-center>
        <v-card>
          <v-card-title class="elevation-1">
            <span>PROMO CODES</span>
            <v-spacer></v-spacer>
            <v-flex pt-5 xl3 lg3 md3 pb-2 sm3 xs3 px-5>
              <v-dialog
                :retain-focus="false"
                v-model="dialog"
                persistent
                max-width="600px"
                :key="dialog"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn outlined color="red" v-bind="attrs" v-on="on">
                    Add
                  </v-btn>
                </template>
                <v-card>
                  <v-form v-model="addslider">
                    <v-card-title>
                      <span class="headline">Add Promo Code</span>
                    </v-card-title>
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="12" md="12">
                            <v-text-field
                              v-model="couponData.description"
                              label="Title"
                              outlined
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="12" md="12">
                            <v-menu
                              ref="menu"
                              v-model="menu"
                              :close-on-content-click="false"
                              :return-value.sync="couponData.vaidFromDate"
                              transition="scale-transition"
                              offset-y
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="couponData.vaidFromDate"
                                  label="Select From Date"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                  outlined
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="couponData.vaidFromDate"
                                no-title
                                scrollable
                              >
                                <v-spacer></v-spacer>
                                <v-btn
                                  text
                                  color="primary"
                                  @click="menu = false"
                                >
                                  Cancel
                                </v-btn>
                                <v-btn
                                  text
                                  color="primary"
                                  @click="
                                    $refs.menu.save(couponData.vaidFromDate)
                                  "
                                >
                                  OK
                                </v-btn>
                              </v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="12" sm="12" md="12">
                            <v-menu
                              ref="menu1"
                              v-model="menu1"
                              :close-on-content-click="false"
                              :return-value.sync="couponData.validToDate"
                              transition="scale-transition"
                              offset-y
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="couponData.validToDate"
                                  label="Select To Date"
                                  outlined
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="couponData.validToDate"
                                no-title
                                scrollable
                              >
                                <v-spacer></v-spacer>
                                <v-btn
                                  text
                                  color="primary"
                                  @click="menu1 = false"
                                >
                                  Cancel
                                </v-btn>
                                <v-btn
                                  text
                                  color="primary"
                                  @click="
                                    $refs.menu1.save(couponData.validToDate)
                                  "
                                >
                                  OK
                                </v-btn>
                              </v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="12" sm="12" md="12">
                            <v-text-field
                              v-model="couponData.maxDiscountAmount"
                              label="Maximum Discount Amount"
                              :rules="Rules"
                              required
                              outlined
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="12" md="12">
                            <v-switch
                              v-model="couponData.isFirstOrder"
                              label="Is First Order"
                              outlined
                            ></v-switch>
                          </v-col>
                          <v-col cols="12" sm="12" md="12">
                            <v-switch
                              v-model="couponData.isOneTime"
                              label="Is One Time"
                              outlined
                            ></v-switch>
                          </v-col>
                          <v-col cols="12" sm="12" md="12">
                            <v-text-field
                              v-model="couponData.promoCode"
                              label="Promo Code"
                              :rules="Rules"
                              required
                              outlined
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="12" md="12">
                            <v-text-field
                              v-model="couponData.discountPercentage"
                              label="Discount Percentage"
                              :rules="Rules"
                              required
                              outlined
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="12" md="12">
                            <ImageComp
                              :singleImage="editingitem.Image"
                              :pageId="editingitem._id"
                              @stepper="winStepper"
                              :height="'190'"
                              :width="'412'"
                              :heading="'Upload Image (412 * 180)'"
                              :componentType="'sliderImage'"
                            />
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="dialogclose()">
                        Close
                      </v-btn>
                      <v-btn
                        color="blue darken-1"
                        text
                        :disabled="!addslider"
                        @click="add()"
                      >
                        Save
                      </v-btn>
                    </v-card-actions>
                  </v-form>
                </v-card>
              </v-dialog>
            </v-flex>
          </v-card-title>
        </v-card>
        <div>
          <v-container grid-list-md>
            <v-layout wrap pt-10 pb-10>
              <v-flex v-for="(item, i) in coupon" :key="i" md3 pa-4>
                <v-card style="" tile flat>
                  <div v-viewer style="display: flex;" v-if="item.photo">
                    <img
                      style="
                          width: 100%;
                          height: 100%;
                          object-fit: cover;
                          cursor: pointer;
                        "
                      :src="mediaUURL + item.photo"
                    />
                  </div>
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular
                        indeterminate
                        color="#FF2323"
                      ></v-progress-circular>
                    </v-row>
                  </template>
                  <v-layout wrap justify-center px-2>
                    <v-flex xl12 md12 sm12 xs12>
                      <span style="font-size: 14px; color: #000000">
                        <b>{{ item.description }}</b>
                      </span></v-flex
                    >
                    <v-flex xl12 md12 sm12 xs12>
                      <span style="font-size: 13px; color: #000000;">
                        Is First Order: {{ item.isFirstOrder }}
                      </span></v-flex
                    >
                    <v-flex xl12 md12 sm12 xs12>
                      <span style="font-size: 13px; color: #000000">
                        Is One Time: {{ item.isOneTime }}
                      </span></v-flex
                    >
                    <v-flex xl12 md12 sm12 xs12>
                      <span style="font-size: 13px; color: #000000">
                        Maximum Discount Amount: {{ item.maxDiscountAmount }}
                      </span></v-flex
                    >
                    <v-flex xl12 md12 sm12 xs12>
                      <span style="font-size: 13px; color: #000000">
                        Discount Percentage: {{ item.discountPercentage }}
                      </span></v-flex
                    >
                    <v-flex xl12 md12 sm12 xs12>
                      <span style="font-size: 13px; color: #000000">
                        Promo Code: {{ item.promoCode }}
                      </span></v-flex
                    >
                    <v-flex pt-5 px-4 xs6 sm6 md6 lg6 xl6 justify-center>
                      <v-dialog v-model="item.delete" max-width="600px">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            small
                            class="mr-2"
                            outlined
                            block
                            v-on="on"
                            v-bind="attrs"
                            color="red"
                          >
                            Delete
                          </v-btn>
                        </template>
                        <v-card>
                          <v-card-title
                            >Are you sure you want to delete this Promo
                            Code?</v-card-title
                          >
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                              color="blue darken-1"
                              text
                              @click="item.delete = false"
                              >Cancel</v-btn
                            >
                            <v-btn
                              color="blue darken-1"
                              text
                              @click="deleteItem(item)"
                              >OK</v-btn
                            >
                            <v-spacer></v-spacer>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </v-flex>
                    <v-flex pt-5 px-4 pb-2 xs6 sm6 md6 lg6 xl6 justify-center>
                      <v-btn
                        small
                        block
                        class="mr-2"
                        outlined
                        color="green"
                        @click="editSlider(item)"
                      >
                        Edit
                      </v-btn>
                    </v-flex>
                    <br />
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </div>
        <v-dialog v-model="editdialog" max-width="600px">
          <v-card>
            <v-card-title>
              <span class="headline">Edit Promo Code</span>
            </v-card-title>
            <v-card-text>
              <v-layout wrap>
                <v-flex xs12 md12 lg12>
                  <v-text-field
                    v-model="editingitem.description"
                    label="Title"
                    outlined
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md12 lg12>
                  <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    :return-value.sync="editingitem.vaidFromDate"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="editingitem.vaidFromDate"
                        label="Select From Date"
                        outlined
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="editingitem.vaidFromDate"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="menu = false">
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu.save(editingitem.vaidFromDate)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 md12 lg12>
                  <v-menu
                    ref="menu1"
                    v-model="menu1"
                    :close-on-content-click="false"
                    :return-value.sync="editingitem.validToDate"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="editingitem.validToDate"
                        label="Select To Date"
                        outlined
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="editingitem.validToDate"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="menu1 = false">
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu1.save(editingitem.validToDate)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 md12 lg12>
                  <v-text-field
                    v-model="editingitem.maxDiscountAmount"
                    label="Maximum Discount Amount"
                    :rules="Rules"
                    required
                    outlined
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md12 lg12>
                  <v-switch
                    v-model="editingitem.isFirstOrder"
                    label="Is First Order"
                    outlined
                  ></v-switch>
                </v-flex>
                <v-flex xs12 md12 lg12>
                  <v-switch
                    v-model="editingitem.isOneTime"
                    label="Is One Time"
                    outlined
                  ></v-switch>
                </v-flex>
                <v-flex xs12 md12 lg12>
                  <v-text-field
                    v-model="editingitem.promoCode"
                    label="Promo Code"
                    :rules="Rules"
                    required
                    outlined
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md12 lg12>
                  <v-text-field
                    v-model="editingitem.discountPercentage"
                    label="Discount Percentage"
                    :rules="Rules"
                    required
                    outlined
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex xs12 md12 lg12>
                  <ImageComp
                    :singleImage="editingitem.photo"
                    :pageId="editingitem._id"
                    @stepper="winStepper"
                    :height="'200'"
                    :width="'412'"
                    :heading="'Upload Image (412 * 180)'"
                    :componentType="'sliderImage'"
                  />
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="editdialog = false">
                Close
              </v-btn>
              <v-btn color="blue darken-1" text @click="edit(editingitem._id)">
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
// import { VueEditor } from "vue2-editor";
import ImageComp from "@/components/Common/singleImage";
export default {
  components: {
    // VueEditor,
    ImageComp,
  },
  props: ["Name"],
  data() {
    return {
      checkbox: true,
      ServerError: false,
      file: null,
      showsnackbar: false,
      msg: null,
      pages: 0,
      code: null,
      widthOfCard: "250px",
      addslider: false,
      appLoading: false,
      currentPage: 1,
      totalData: 0,
      totalRows: 0,
      dialogDelete: false,
      search: "",
      dialog: false,
      editdialog: false,
      imgId: "",
      editingitem: [],
      menu1: false,
      menu: false,
      coupon: [],
      couponData: {
        discountPercentage: null,
        promoCode: null,
        description: "",
        vaidFromDate: new Date().toISOString().substr(0, 10),
        validToDate: new Date().toISOString().substr(0, 10),
        maxDiscountAmount: "",
        isOneTime: true,
        isFirstOrder: true,
      },
      nameRules: [
        (v) => !!v || "Name is required",
        (v) => (v && v.length <= 15) || "Name must be less than 15 characters",
      ],
      Rules: [(value) => !!value || "Required."],
    };
  },
  beforeMount() {
    this.getData();
  },
  methods: {
    winStepper(window_data) {
      if (window_data.type == "sliderImage") {
        this.sliderImage = window_data.selectedFiles;
      }
    },
    getData() {
      this.appLoading = true;
      axios({
        url: "/promocode/getlist/admin",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          count: this.count,
          page: this.currentPage,
          Name: this.Name,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.coupon = response.data.data;
          this.pages = response.data.pages;
          this.totalData = response.data.count;
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    add() {
      axios({
        url: "/admin/add/promocode",
        method: "POST",
        data: this.couponData,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.imgId = response.data.data._id;
            if (this.sliderImage) {
              this.uploadImage(this.imgId);
            } else {
              this.getData();
            }
            this.msg = "Added Sucessfully";
            this.showsnackbar = true;
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.$emit("stepper", {
            ServerError: true,
          });
          console.log(err);
        });
    },
    deleteItem(id) {
      var data = {};
      data["id"] = id._id;
      axios({
        url: "/promocode/delete",
        method: "POST",
        data: data,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.dialogDelete = false;
          this.appLoading = false;
          if (response.data.status) {
            this.msg = "Delete Sucessfully";
            this.showsnackbar = true;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    dialogclose() {
      this.link = null;
      this.dialog = false;
    },
    editSlider(item) {
      this.editingitem = item;
      this.editdialog = true;
      this.editingitem.vaidFromDate = this.editingitem.vaidFromDate.slice(
        0,
        10
      );
      this.editingitem.validToDate = this.editingitem.validToDate.slice(0, 10);
    },
    edit() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/admin/edit/promocode",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          description: this.editingitem.description,
          id: this.editingitem._id,
          promoCode: this.editingitem.promoCode,
          isFirstOrder: this.editingitem.isFirstOrder,
          vaidFromDate: this.editingitem.vaidFromDate,
          validToDate: this.editingitem.validToDate,
          maxDiscountAmount: this.editingitem.maxDiscountAmount,
          isOneTime: this.editingitem.isOneTime,
          discountPercentage: this.editingitem.discountPercentage,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            if (this.sliderImage) {
              this.uploadImage(this.editingitem._id);
            } else {
              this.getData();
              this.msg = "Edited Sucessfully";
            }
            this.showsnackbar = true;
            this.editdialog = false;
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    uploadImage(id) {
      let formData = new FormData();
      formData.append("id", id);
      formData.append("photo", this.sliderImage);
      axios({
        method: "POST",
        url: "/promocode/UploadImagesingle",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.getData();
            this.showsnackbar = true;
            this.msg = "Uploaded Successfully";
            this.imagePreview = null;
            this.file = null;
            this.dialog = false;
          } else {
            this.msg = "Can't Update";
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>
